module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bottombar-large",
    staticStyle: {
      "margin-top": "5em",
      "margin-left": "-2em",
      "width": "400px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-left": "1em"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Timeline")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/shop"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _c('br'), _c('span', [_vm._v("Shop")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottombar",
    staticStyle: {
      "margin-top": "15em",
      "margin-left": "-2em",
      "width": "150%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "2.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _c('br'), _c('span', [_vm._v("Timeline")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('br'), _c('span', [_vm._v("Account")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _c('br'), _c('span', [_vm._v("Notifications")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/cart"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _c('br'), _c('span', [_vm._v("Bag")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/account"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _c('br'), _c('span', [_vm._v("Settings")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f196116a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/menubottom.vue
// module id = 275
// module chunks = 0